import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowTriangleLeft"><Path d="M19.25 17.252V6.74803C19.25 5.26465 17.6884 4.29985 16.3611 4.96324L5.85345 10.2152C4.38218 10.9506 4.38218 13.0494 5.85345 13.7848L16.3611 19.0368C17.6884 19.7001 19.25 18.7354 19.25 17.252Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowTriangleLeft;
